export default {
    state: {
        isCollapse: false
    },
    mutations:{
        collapseMeau(state) {
            state.isCollapse =! state.isCollapse
        }
    }
}